import React from 'react';
import {Router,Route } from 'react-router';
import { connect } from 'react-redux';
import { history, store } from '../helpers';
import { PrivateRoute, Login, Navbar } from './';
import { Sertifikalar, Egitimler, Drivers, CreateDriver, Onay } from './PanelPages';
import '../assets/styles/App.css';
import '../assets/styles/Egitimler.css';
import '../assets/styles/Datepicker.css';
class App extends React.Component {

    renderNavHeader(loggedIn){
        const userType = localStorage.getItem('userType');
        if(loggedIn){
            if( userType === 'm1' || userType === 'm2')
                return(
                    <Navbar userType ={userType}>
                        <PrivateRoute exact path='/' component={Drivers} />
                        <Route path="/Drivers" component={Drivers} />
                        <Route path="/Sertifikalar" component={Sertifikalar} />
                        <Route path="/Egitimler" component={Egitimler} />
                    </Navbar>
                );
            else if(userType === 'instructor'){
                return(
                    <Navbar userType ={userType}>
                        <PrivateRoute exact path='/' component={CreateDriver} />
                        <Route path="/Egitimler" component={Egitimler} />
                    </Navbar>
                );
            }
            else if(userType === 'admin'){
                return(
                    <Navbar userType={userType}>
                        <PrivateRoute exact path='/' component={Drivers} />
                        <Route exact path='/Drivers' component={Drivers} />
                        <Route path="/Sertifikalar" component={Sertifikalar} />
                        <Route path="/Onay" component={Onay} />
                    </Navbar>
                );
            }
        }
        return(
            <PrivateRoute exact path='/' component={Drivers} />
        );  
    }
  
    render() {
        const { loggedIn } = this.props;
        return (
            <div>
          
                <Router history={history}>
                    <div>      
                        <Route path="/login" component={Login} />
                        {this.renderNavHeader(loggedIn)}
                    </div>
                </Router>  
            </div>
      
        );
    }
}

function mapStateToProps(state) {
    const {loggedIn} = state.authentication;

    return {
        alert,
        loggedIn
    };
}

const connectedApp = connect(mapStateToProps)(App);
export { connectedApp as App }; 


// WEBPACK FOOTER //
// ./src/components/App.jsx